"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMatAvaliacAlunoOnline = exports.yupMatAvaliacAlunoOnline = exports.schemaAvaliacaoAlunoOnline = exports.yupAvaliacaoAlunoOnline = void 0;
const yup = __importStar(require("yup"));
const avaliac_1 = require("../avaliac");
exports.yupAvaliacaoAlunoOnline = yup
    .object({
    nota: yup.string().notRequired().nullable().optional().default(undefined).label('Nota'),
    notaSubstitutiva: yup.string().notRequired().nullable().default(undefined).label('Substitutiva'),
    idAvaliacao: yup.number().required().label('ID da avaliação'),
    valor: yup.string().required().label('Valor da avaliação'),
    idMensagem: yup.number().notRequired().nullable().optional().label('ID do conteúdo da avaliação'),
    conteudoAvaliacao: yup
        .string()
        .notRequired()
        .nullable()
        .optional()
        .default(undefined)
        .label('Texto do conteúdo da avaliação'),
})
    .concat(avaliac_1.yupAvaliacao.pick(['descricao', 'data']));
exports.schemaAvaliacaoAlunoOnline = exports.yupAvaliacaoAlunoOnline.shape({});
exports.yupMatAvaliacAlunoOnline = yup.object({
    nomeProfessor: yup.string().notRequired().nullable().default(undefined).label('Nome do professor'),
    idProfessor: yup.number().notRequired().nullable().default(undefined).label('ID do professor'),
    nomeMateria: yup.string().notRequired().nullable().default(undefined).label('Nome da matéria'),
    idMateria: yup.number().notRequired().nullable().default(undefined).label('ID da matéria'),
    media: yup.string().notRequired().nullable().default(undefined).label('Média da matéria'),
    mediaFinal: yup.string().notRequired().nullable().default(undefined).label('Média da final do bimestre'),
    recuperacao: yup.string().notRequired().nullable().default(undefined).label('Recuperação do bimestre'),
    concluido: yup.boolean().required().default(false).label('Bimestre concluído'),
});
exports.schemaMatAvaliacAlunoOnline = exports.yupMatAvaliacAlunoOnline.shape({});
